import { render } from "./SchoolsTable.vue?vue&type=template&id=1e1faae5&scoped=true"
import script from "./SchoolsTable.vue?vue&type=script&lang=js"
export * from "./SchoolsTable.vue?vue&type=script&lang=js"

import "./SchoolsTable.vue?vue&type=style&index=0&id=1e1faae5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e1faae5"]])

export default __exports__